var v1="<div><div ng-if=\"floatNumber\" class=\"value\">{{ integerPart }}<span class=\"small\">{{ fractionPart }}{{prefix}}</span></div><div ng-if=\"!floatNumber\" class=\"value\">-</div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/number/small-sized-decimal.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/number/small-sized-decimal.jade
// module id = 392
// module chunks = 0